export default {
  // 公共
  cancel: '取消',
  confirm: '确定',
  tip: '提示',
  loading: '加载中...', // 加载中...
  noData: '暂无数据',
  noMoreData: '没有更多数据啦~', // 没有更多数据啦
  refreshText: '下拉刷新', // 下拉刷新
  refreshActiveText: '释放刷新', // 释放刷新
  refreshingText: '刷新中...', // 刷新中...
  copySuccess: '复制成功',
  copyFailed: '复制失败',
  noSupportVideoFormat: '不支持该视频格式',
  tokenNoValid: '登录失效，请重新登录',
  loginAgain: '请重新登录',
  logoutSuccess: '退出成功',
  pleaseLogin: '请登录', // 请登录
  just: '刚刚',
  minsAgo: '分钟前', //  例如： 6分钟前
  hoursAgo: '小时前', // 例如： 6小时前
  daysAgo: '天前',
  cYear: '年',
  cDay: '日',
  cMonth: '月',
  month: '月',
  hour: '时',
  minute: '分',
  tokenTips: '您需要登录注册后才可进行操作哦！', // 您需要登录注册后才可进行操作哦！
  chooseStartDate: '选择开始日期',
  chooseEndDate: '选择结束日期',
  dateCustomQuery: '自定义查询',
  customStartDate: '开始日期',
  customEndDate: '结束日期',
  dateTips: '开始时间不得大于结束时间',
  noVipTips: '您还不是VIP！',
  contactCustomer: '请联系客服',
  networkAnomaly: '网络异常',
  shareFailByNotAudit: '分享失败,审核未通过', // 分享失败
  status: '状态',

  // 语言
  langChinese: '中文（繁体）', // 中文（繁体）
  langVn: '越南语', // 越南语
  langEnglish: '英语', // 英语

  // 底部菜单
  footerHome: '首页', // 首页
  footerHot: '热门', // 热门
  footerUploadVideo: '上传短视频', // 上传短视频
  footerCs: '客服', // 客服
  footerMine: '我', // 我

  // 客服
  customerService: '客服', // 客服
  customerRespect: 'Hi，尊敬的', // Hi，尊敬的
  customerTourists: '游客', // 游客
  customerWelcome: '欢迎来到客服中心', // 欢迎来到客服中心
  customerOnline: '在线客服', // 在线客服
  customer24: '7x24小时专线服务贴心至上', // 7x24小时专线服务贴心至上

  // 首页
  homeChangeNation: '地区切换', // 地区切换
  homeEnter: '进入', // 进入
  homeLongVideo: '影片', // 影片
  homeShortVideo: '短视频', // 短视频
  homeNoOpenNet: '该功能暂未开放！', // 该功能暂未开放！
  homeChooseLang: '选择语言', // 选择语言
  myQrcode: '我的二维码', // 我的二维码
  downloadApp: '下载app', // 下载app
  addFriend: '添加朋友', // 添加朋友
  scanMe: '扫一扫，立即关注我', // 扫一扫，立即关注我
  saveQrcode: '保存', // 保存
  chooseCurrency: '选择货币', // 选择货币

  // 长电影
  homeLongRecommend: '今日推荐', // 今日推荐
  homeLongChange: '换一批', // 换一批

  // 短视频
  homeShort: '今日推荐', // 今日推荐

  // 发布视频
  homeNovel: '小说',
  homeRecommend: '推荐',
  homeChoice: '分类',
  homeRank: '排行',
  homeFree: '免费',
  homeCompleted: '完本',
  homeNotCompleted: '连载',
  homeMore: '更多',
  homePublishIntro: '在这里写点描述，让更多人看到～', // 在这里写点描述，让更多人看到～
  homePublishChooseCover: '选封面', // 选封面
  homePublishLabel: '标签', // 标签
  homePublishBtn: '发布', // 发布
  homePublishPublic: '公开·所有人可见', // 公开·所有人可见
  homePublishPrivate: '私密·仅自己可见', // 私密·仅自己可见
  homePublishing: '短视频上传中，请稍候', // 短视频上传中，请稍候
  homePublishFailed: '短视频上传失败，请重新上传', // 短视频上传失败，请重新上传
  homePublishUploadCover: '请上传封面图', // 请上传封面图
  homePublishVideoSuccess: '作品上传成功', // 上传成功提示
  homePrivatePublished: '您的作品已发布并由工作人员审核！您可以在个人主页作品里查看该作品', // 私密发布提示
  homePublishCancel: '我再想想', // 取消发布
  homePublishConfirm: '好的', // 私密发布成功确认
  homePublishCancelTips: '如果您取消发布，系统将不会保留您的当前编辑', // 关闭确认
  publishTitle: '发布信息',
  clickUploadVideo: '点击上传视频',
  videoSizeMsg: '视频大小不超过100M',
  clickUploadCoverImg: '点击上传封面',
  coverImgMsg: '封面必须与视频内容一致',
  whoView: '谁可以看',
  writeTitle: '填写标题',
  writeTitleMsg: '好的标题可提升视频点击率',
  writeTitlePlaceholder: '填写符合视频内容的标题',
  writePrice: '设定价格',
  writePricePlaceholder: '请输入价格',
  memberPicker: '会员选择',
  videoPreview: '视频预览',
  videoPreviewMsg: '发布后普通用户可观看的时长限制（5～15秒）',
  videoPreviewPlaceholder: '请输入可观看时间（5～15秒）',
  videoLabel: '视频标签',
  videoLabelMsg: '选择最符合视频内容的标签，最多4个',
  allPeople: '所有人',
  memberUsers: '会员用户',
  ordinaryUsers: '普通用户',
  uploadVideoMsg: '请上传视频',

  // hot
  hotLongVideo: '热门影片', // 热门影片
  hotShortVideo: '热门短视频', // 热门短视频
  hotOverview: '总览',
  hotAllTime: '所有时间',
  hotMonth: '本月热门',
  hotWeek: '本周热门',
  hotDay: '本日热门',
  hotFilmCount: '{0}部影片', // 选择货币
  hotFilmEmpty: '暂无热门影片~',

  // 影片
  hotLong: '热门影片', // 热门影片

  // 热门短视频
  hotShort: '查看热榜', // 查看热榜
  hotShortHotList: '热搜榜', // 热搜榜

  // 找回密码
  restPassword: '找回密码', // 找回密码
  restPasswordVerifySent: '验证码已发送至', // 验证码已发送至
  restPasswordPsdRule: '密码需要6-20位，纯数字、纯字母，或者任意组合', // 密码需要6-20位，纯数字、纯字母，或者任意组合
  restPasswordEnterVerifyCode: '请输入验证码', // 请输入验证码
  restPasswordEnterNewPsd: '请输入新密码', // 请输入新密码
  restPasswordSelected: '请先勾选，同意后再进行登录', // 请先勾选，同意后再进行登录
  restPasswordAgree: '已阅读并同意', // 已阅读并同意
  restPasswordContract: '用户协议', // 用户协议
  restPasswordAnd: '和', // 和
  restPasswordPrivate: '隐私政策', // 隐私政策
  restPasswordFinished: '完成', // 完成
  restPasswordRestFailed: '重置密码失败', // 重置密码失败

  // 登录
  login: '登录', // 登录
  loginEmail: '邮箱号登录', // 邮箱号登录
  loginPhone: '手机号登录', // 手机号登录
  loginEnterPhoneNum: '请输入手机号', // 请输入手机号
  loginEnterEmail: '请输入邮箱号', // 请输入邮箱号
  loginEnterAccount: '请输入用户名', // 请输入用户名
  loginEnterEmailOrAccount: '请输入邮箱/用户名', // 请输入邮箱/用户名
  loginEnterPhoneOrAccount: '请输入账号或手机号', // 请输入账号或手机号
  loginEnterPsd: '请输入登录密码', // 请输入登录密码
  loginEnterRePsd: '再次输入密码', // 再次输入输入密码
  // restPasswordSelected: '请先勾选，同意后再进行登录', // 请先勾选，同意后再进行登录
  // restPasswordAgree: '已阅读并同意', // 已阅读并同意
  // restPasswordContract: '用户协议', // 用户协议
  // restPasswordAnd: '和', // 和
  // restPasswordPrivate: '隐私政策', // 隐私政策
  loginForget: '忘记了？', // 忘记了？
  // restPassword: '找回密码', // 找回密码
  loginEmailPsd: '邮箱/用户名登录', // 邮箱密码登录
  loginPhonePsd: '手机密码登录', // 手机密码登录
  loginCountryArea: '选择国家和地区', // 选择国家和地区
  loginVn: '越南', // 越南
  loginPh: '菲律宾', // 菲律宾
  loginFailed: '登录失败', // 登录失败
  loginVerifyCodeSent: '验证码已发送', // 验证码已发送
  loginVerifyCodeSentFailed: '验证码发送失败', // 验证码发送失败
  loginTitle: '登录发现更多精彩',
  // 注册
  register: '注册',
  registerTitle: '登录发现更多精彩', // 登录发现更多精彩
  // restPasswordSelected: '请先勾选，同意后再进行登录', // 请先勾选，同意后再进行登录
  // restPasswordAgree: '已阅读并同意', // 已阅读并同意
  // restPasswordContract: '用户协议', // 用户协议
  // restPasswordAnd: '和', // 和
  // restPasswordPrivate: '隐私政策', // 隐私政策
  registerAnd2: '以及', // 以及
  registerContract2: '运营商服务协议', // 运营商服务协议
  registerCheckPhone: '运营商将对你提供的手机号进行验证', // 运营商将对你提供的手机号进行验证
  registerCheckEmail: '运营商将对你提供的邮箱号进行验证', // 运营商将对你提供的邮箱号进行验证
  // loginEnterPhoneNum: '请输入手机号', // 请输入手机号
  // loginEnterEmail: '请输入邮箱号', // 请输入邮箱号
  registerByPhone: '未注册的手机号验证通过后将自动注册', // 未注册的手机号验证通过后将自动注册
  registerByEmail: '未注册的邮箱号验证通过后将自动注册', // 未注册的邮箱号验证通过后将自动注册
  // loginEmail: '邮箱号登录', // 邮箱号登录
  // loginPhone: '手机号登录', // 手机号登录
  registerVerifyLogin: '验证并登录', // 验证并登录
  registerPadLogin: '密码登录', // 密码登录
  // restPasswordEnterVerifyCode: '请输入验证码', // 请输入验证码
  // restPasswordVerifySent: '验证码已发送至', // 验证码已发送至
  registerNext: '下一步', // 下一步
  // login: '登录', // 登录
  registerSetLoginPsd: '请设置登录密码', // 请设置登录密码
  // restPasswordPsdRule: '密码需要6-20位，纯数字、纯字母，或者任意组合', // 密码需要6-20位，纯数字、纯字母，或者任意组合
  registerConfirm: '确认', // 确认
  // loginEnterPsd: '请输入登录密码', // 请输入登录密码
  registerContract3: '温馨提示', // 温馨提示
  registerSafe: '我们将严格保护你的个人信息安全', // 我们将严格保护你的个人信息安全
  registerAge: '请问您是否满18岁', // 请问您是否满18岁
  registerAgreeAndLogin: '是', // 是
  registerDisAgree: '否', // 否
  // loginCountryArea: '选择国家和地区', // 选择国家和地区
  // loginVn: '越南', // 越南
  // loginPh: '菲律宾', // 菲律宾
  // loginVerifyCodeSent: '验证码已发送', // 验证码已发送
  // loginVerifyCodeSentFailed: '验证码发送失败', // 验证码发送失败

  // 影片大厅
  longVideoLobbySearch: '请输入关键词查找片源', // 请输入关键词查找片源
  longVideoLobbySearchBtn: '搜索', // 搜索
  longVideoLobbyBest: '近期最佳', // 近期最佳
  longVideoLobbyNewUpdate: '最近更新', // 最近更新
  longVideoLobbyMoreView: '最多观看', // 最多观看
  longVideoLobbyCollect: '最高收藏', // 最高收藏
  longVideoLobbyChooseVideo: '选片', // 选片
  longVideoLobbyLabel: '标签', // 标签
  longVideoLobbyMovieNum: '{num}部影片', // xxx部影片
  longVideoLobbyDefault: '预设排序', // 预设排序
  longVideoLobbyHot: '热度优先', // 热度优先
  longVideoLobbyMoreCollect: '最多收藏', // 最多收藏

  // 搜索短视频
  // longVideoLobbySearch: '请输入关键词查找片源', // 请输入关键词查找片源
  // longVideoLobbySearchBtn: '搜索' // 搜索
  shortSearchNodata: '暂无搜索记录', // 暂无搜索记录
  shortSearchAllHistory: '全部搜索记录', // 全部搜索记录
  shortSearchClearAllHistory: '清除全部搜索记录', // 清除全部搜索记录
  shortSearchHotList: '短视频热榜', // 短视频热榜

  // 影片详情
  videoDetailVipTitle1: '本片是VIP会员专享内容', // 本片是VIP会员专享内容
  videoDetailVipTitle2: '请开通VIP会员观看', // 请开通VIP会员观看
  videoDetailVipTitle3: '开通VIP会员', // 开通VIP会员
  videoDetailBrief: '简介', // 简介
  videoDetailShare: '分享', // 分享
  videoDetailContent: '剧情', // 剧情
  videoDetailRecommend: '为您推荐', // 为您推荐
  videoDetailCountDown: '{countDownTime}秒后关闭广告', // 5秒后关闭广告
  videoDetailCloseAd: '关闭广告', // 关闭广告

  // 个人中心
  // 关注和粉丝列表
  mineFollowing: '关注', // 关注
  mineFollower: '粉丝', // 粉丝
  mineFollowed: '已关注', // 已关注
  mineFollowMyself: '自己', // 自己
  mineFollowEach: '互相关注', // 互相关注
  mineFollowBack: '回关', // 回关
  mineFollowCancel: '取消关注', // 取消关注
  mineFollowHim: '他的/她的', // 他的/她的
  mineFollowMe: '我的', // 我的
  mineFollowPerson: '人', // 人
  memberCard: '会员卡',
  wallet: '钱包',
  shareInvitation: '分享邀请',
  promotionMoney: '推广赚钱',
  fanGroup: '粉丝团',
  drivingGroup: '加群开车',
  createCenter: '创作者中心',
  community: '社区贴文',
  myBuy: '我的购买',
  gold: '金币',

  // vip中心
  vipCenter: 'VIP中心',
  // 观看历史
  historyTitle: '观看历史', // 观看历史
  maxGift: '最高赠送{money}币',
  freeForeverWatch: '非原创VIP视频永久免费观看',
  dayFreeWatch: 'VIP视频免费观看{day}天',
  videoPayFreeWatch: '金币付费视频每日免费观看{num}部',
  carGroup: '解锁全国外围开车群',
  welfareGroup: '解锁黑料福利群',
  routeMovie: '专属高清看片路线极速播放',
  paymentMsg: '支付提醒',
  payNow: '立即支付',

  // 设置
  settingSafeTitle: '账号与安全', // 账号与安全
  settingSafeAvatar: '头像', // 头像
  settingSafeUserName: '用户名', // 用户名
  settingSafeNickName: '昵称', // 昵称
  settingSafeInviteCode: '邀请码', // 邀请码
  settingSafeEditPsd: '修改登录密码', // 修改登录密码
  settingSafeUploadAvatar: '上传头像', // 上传头像
  settingSafeUpload: '上传', // 上传
  settingSafeChoosePic: '请选择图片！', // 请选择图片！
  settingSafeUploadFailed: '上传失败', // 上传失败

  // 修改登录密码
  settingTitle: '设置', // 设置
  settingChangeLang: '语言切换', // 语言切换
  settingUpdateLoginPsd: '修改登录密码', // 修改登录密码
  settingGetVerifyCode: '获取验证码', // 获取验证码
  settingUpdateLoginCheckNewPsd: '确认新的登录密码', // 确认新的登录密码
  settingUpdateLoginNewPsd: '请输入新的登录密码', // 请输入新的登录密码
  settingUpdateFailed: '修改失败', // 修改失败
  settingUpdateByPhone: '通过手机号修改登录密码', // 通过手机号修改登录密码
  settingUpdateByEmail: '通过邮箱号修改登录密码', // 通过邮箱号修改登录密码

  // 任务中心
  taskTitle: '任务中心', // 任务中心
  taskDaily: '每日任务', // 每日任务
  taskFinished: '已完成', // 已完成
  taskGo: '去完成', // 去完成

  // 修改用户资料
  userInfoEditBg: '更换背景', // 更换背景
  userInfoEditProcess: '资料完成度', // 资料完成度
  userInfoEditAvatar: '点击更换头像', // 点击更换头像
  userInfoEditMale: '男', // 男
  userInfoEditFemale: '女', // 女
  userInfoEditPrivate: '保密', // 保密
  userInfoEditNickName: '昵称', // 昵称
  userInfoEditUpdateNickName: '修改昵称', // 设置昵称
  userInfoEditSetNickName: '设置昵称', // 设置昵称
  userInfoEditBrief: '简介', // 简介
  userInfoEditIntroduce: '介绍一下自己', // 介绍一下自己
  userInfoEditFullInfo: '完善信息加+10%', // 完善信息加+10%
  userInfoEditGender: '性别', // 性别
  userInfoEditChoseGender: '选择性别', // 选择性别
  userInfoEditBirthday: '生日', // 生日
  userInfoEditChooseBirthday: '选择生日', // 选择生日
  userInfoEditAddress1: '所在地', // 所在地
  userInfoEditAddress2: '你在哪儿', // 你在哪儿
  userInfoEditPhone: '手机号', // 手机号
  userInfoEditPhone1: '填写你的手机号', // 填写你的手机号
  userInfoEditEmail: '邮箱', // 邮箱
  userInfoEditEmail1: '填写你的邮箱号', // 填写你的邮箱号
  userInfoEditInviteCode: '邀请码', // 邀请码
  userInfoEditUploadBg: '上传背景图', // 上传背景图
  userInfoEditToday: '今天', // 今天
  userInfoEditSave: '保存', // 保存
  userInfoEditMyNickName: '我的昵称', // 我的昵称
  userInfoEditAddress3: '所在地区', // 所在地区
  userInfoEditAddress4: '地址', // 地址
  userInfoEditUpdate: '修改', // 修改
  userInfoEditSet: '设置', // 设置
  userInfoVipTime: 'VIP会员至', // VIP会员至

  // 用户中心
  userDetailIntro: '点击添加介绍，让大家认识你', // 点击添加介绍，让大家认识你
  userDetailLogout: '退出登录', // 退出登录
  userDetailGetLike: '获赞', // 获赞
  userDetailWork: '作品', // 作品
  userDetailPrivate: '私密', // 私密
  userDetailLike: '喜欢', // 喜欢
  userDetailCollect: '收藏', // 收藏
  userDetailLogoutFailed: '退出失败', // 退出失败
  userDetailDepositCenter: '充值中心', // 充值中心
  userDetailEditInfo: '编辑资料', // 编辑资料
  userDetailAddFriend: '添加好友', // 添加好友
  userDetailMessage: '私信', // 私信

  // 评论组件
  commentCount: '条评论', // xxx条评论
  commentPlaceholder: '来一起说点什么吧～', // 来一起说点什么吧～
  commentSend: '发送', // 发送
  commentContent: '请输入评论内容', // 请输入评论内容

  // 我的钱包
  myWallet: '我的钱包', // 我的钱包
  myBalance: '总资产', // 总资产
  myAToken: 'A币', // A币
  myIncome: '我的收益', // 我的收益
  myReceiptWay: '收款方式', // 收款方式
  myWithdraw: '提现', // 提现
  myBills: '账单', // 账单
  questionsTitle: '常见问题', // 常见问题
  whatIsATitle: '1、A币是什么？', // 1、A币是什么？
  whatIsATips1: '余额是在{siteTitle}支付中的资金，聊天直播收到的红包、赚取的收入可以存入零钱、支持消费，红包，打赏，提现等功能', // 余额是在Titok支付中的资金，聊天直播收到的红包、赚取的收入可以存入零钱、支持消费，红包，打赏，提现等功能
  whatIsATips2: 'A币和人民币1:1换算', // A币和人民币1:1换算
  whatIsATips3: 'A币和泰达币（火币网实时汇率）换算', // A币和泰达币（火币网实时汇率）换算
  whatIsATips4: 'A币和越南盾根据公司实时汇率换算', // A币和越南盾根据公司实时汇率换算
  whatIsIncomeTitle: '2、我的收益是什么？', // 2、我的收益是什么？
  whatIsIncomeTips1: '我的收益实在你完成签到任务，完成活动，达到推广指标后获得的A币，支持消费，红包，打赏，提现等功能。', // 我的收益实在你完成签到任务，完成活动，达到推广指标后获得的A币，支持消费，红包，打赏，提现等功能。
  payWaysTitle: '3、收款方式支持哪些？', // 2、我的收益是什么？
  payWaysTips1: '如果您是大陆用户，那么我们将会提供银行卡/微信/支付宝/泰达币等提现方式；', // 如果您是大陆用户，那么我们将会提供银行卡/微信/支付宝/泰达币等提现方式；
  payWaysTips2: '如过您是越南用户，那么我们将会提供Gcash/越南银行/vsira/泰达币等提现方式；', // 如过您是越南用户，那么我们将会提供Gcash/越南银行/vsira/泰达币等提现方式；
  payWaysTips3: '如果您是欧美用户，那么我们将会提供泰达币提现方式；', // 如果您是欧美用户，那么我们将会提供泰达币提现方式；
  payWaysTips4: '点击收款方式进入页面绑定对应的收款方式在提现时选择该方式提现即可。', // 点击收款方式进入页面绑定对应的收款方式在提现时选择该方式提现即可。

  // 充值中心
  depositAToken: '充值A币', // 充值A币
  depositVip: '充值会员', // 充值会员
  depositChannel: '收款通道', // 收款通道
  depositOfflineInfo: '收款信息', // 收款信息
  depositCurrencyName: '货币名称', // 货币名称
  depositCurrencyLink: '货币链路', // 货币链路
  depositCurrencyAddress: '货币地址', // 货币地址
  depositPayerAddress: '汇款人地址', // 汇款人地址
  depositPayerAddressHint: '请输入汇款人地址', // 请输入汇款人地址
  depositAmount: '存款金额', // 存款金额
  depositChooseAmount: '请选择金额', // 请选择金额
  depositInputAmount: '请输入金额', // 请输入金额
  // depositTips: '注：最小充值{min}{unit}；最大充值{max}{unit}', // 注：最小充值xx元；最大充值xx元
  depositTipsMin: '注：最小充值{min}{unit}；', // 注：最小充值xx元；最大充值xx元
  depositTipsMax: '最大充值{max}{unit}', // 注：最小充值xx元；最大充值xx元
  depositSubmit: '确定提交', // 确定提交
  depositNoChannel: '暂无收款通道~', // 暂无收款通道~
  depositPayFailed: '支付失败', // 支付失败
  depositDay: '天', // 天
  depositPleaseChoose: '请选择', // 请选择

  // 收款方式
  withdrawalWays: '收款方式', // 收款方式
  withdrawalAlipayName: '支付宝姓名', // 支付宝姓名
  withdrawalAlipayAccount: '支付宝账号', // 支付宝账号
  withdrawalShowAlipayAccount: '显示支付宝账号', // 显示支付宝账号
  withdrawalCheckQrcode: '查看二维码', // 查看二维码
  withdrawalWechatName: '微信名称', // 微信名称
  withdrawalUsername: '用户姓名', // 用户姓名
  withdrawalBankAccount: '银行卡号', // 银行卡号
  withdrawalShowBankAccount: '显示银行卡号', // 显示银行卡号
  withdrawalBankName: '银行名称', // 银行名称
  withdrawalWalletName: '钱包名称', // 钱包名称
  withdrawalWalletAddress: '钱包地址', // 钱包地址
  withdrawalTokenName: '币种名称', // 币种名称
  withdrawalTokenLink: '链路名称', // 链路名称
  withdrawalAddress: '收款地址', // 收款地址
  withdrawalAdd: '添加收款方式', // 添加收款方式
  withdrawalClose: '关闭', // 关闭
  withdrawalAll: '全部', // 全部

  // 修改收款方式
  withdrawalWaysChoose: '请选择收款方式', // 请选择收款方式
  withdrawalWaysNo: '暂无收款方式', // 暂无收款方式
  withdrawalWaysInputInfo: '填充信息', // 填充信息
  withdrawalWaysWechatAccount: '微信号', // 微信号
  withdrawalWaysUploadQrcode: '上传收款码', // 上传收款码
  withdrawalWaysUploadMyQrcode: '上传我的收款码', // 上传我的收款码
  withdrawalWaysPassword: '取款密码', // 取款密码
  withdrawalWaysInputWechatName: '请输入微信名称', // 请输入微信名称
  withdrawalWaysInputAlipayName: '请输入支付宝姓名', // 请输入支付宝姓名
  withdrawalWaysInputUserName: '请输入用户姓名', // 请输入用户姓名
  withdrawalWaysInputWechatAccount: '请输入微信号', // 请输入微信号
  withdrawalWaysInputAlipayAccount: '请输入支付宝账号', // 请输入支付宝账号
  withdrawalWaysInputBankAccount: '请输入银行卡号', // 请输入银行卡号
  withdrawalWaysInputBankName: '请输入银行名称', // 请输入银行名称
  withdrawalWaysInputWalletAddress: '请输入钱包地址', // 请输入钱包地址
  withdrawalWaysInputAddress: '请输入收款地址', // 请输入收款地址
  withdrawalWaysInputPassword: '请输入取款密码', // 请输入取款密码
  withdrawalWaysModify: '修改', // 修改
  withdrawalWaysAdd: '添加', // 添加
  withdrawalWaysTips: '温馨提示：如您没有设置取款密码，首次绑定收款方式时，您输入的取款密码将作为默认取款密码使用', // 温馨提示：如您没有设置取款密码，首次绑定收款方式时，您输入的取款密码将作为默认取款密码使用
  withdrawalWaysModifyFailed: '修改失败', // 修改失败
  withdrawalWaysAddFailed: '添加失败', // 添加失败

  // 提现
  withdrawal: '提现', // 提现
  withdrawalChooseWays: '请选择提现方式', // 请选择提现方式
  withdrawalAccount: '提现账户', // 提现账户
  withdrawalAmount: '提现数量', // 提现数量
  withdrawalInputAmount: '请输入提现数量（ANTG）', // 请输入提现数量（ANTG）
  withdrawalBalance: '可提现余额', // 可提现余额
  withdrawalTipsTitle: '提现规则', // 提现说明
  withdrawalTips1: '提现时间：24小时内随时提现', // 提现时间：24小时内随时提现
  withdrawalTips2: '单笔提现限额：100个币起', // 单笔提现限额：100个币起
  withdrawalNoways: '您还未绑定该收款信息！', // 您还未绑定该收款信息！
  withdrawalFailed: '提现失败', // 提现失败

  // 新的
  withdrawalConfirm: '确认提现', // 提现

  // 钱包设置
  walletSetting: '设置', // 设置
  walletModifyWithDrawPsd: '修改取款码', // 修改取款码
  bindMobile: '您首先需要绑定手机号', // 您首先需要绑定手机号

  // 修改取款码
  walletModifyWithDrawPsdByPhone: '通过手机修改取款码', // 通过手机修改取款码
  walletModifyWithDrawPsdByEmail: '通过邮箱修改取款码', // 通过邮箱修改取款码
  walletModifyWithDrawPsdConfirm: '确认新的取款密码', // 确认新的取款密码
  walletModifyWithDrawPsdInput: '请输入取款码', // 请输入取款码

  // 账单
  billTitle: '账单',
  billSelectTypeTitle: '选择交易类型',
  billAll: '全部',
  billTo: '至',
  // vip中心
  lookRules: '查看规则',
  vipRules: '会员规则',
  vipOrdinary: '普通会员',
  vipTimeTo: 'VIP会员至',
  vipJoinNow: '快加入VIP吧！',
  doDeposit: '去充值',
  vipPrivilege: 'VIP特权',
  vipDetail: 'VIP详情',
  upMoney: '晋级彩金',
  viewingTimes: '观影次数',
  vipMovie: 'VIP影片',
  vipNovel: 'VIP小说',
  vipCartoon: 'VIP漫画',
  unlimitedViewing: '无限观看',
  pleaseWaiting: '敬请期待',
  moviePlayTimes: '影片观看次数',
  movieLikeTimes: '影片点赞次数',
  movieCommentTimes: '影片评论次数',
  movieCollectTimes: '影片收藏次数',
  shortVideoPlayTimes: '短视频观看次数',
  shortVideoAwesomeTimes: '短视频点赞次数',
  shortVideoCommentTimes: '短视频评论次数',
  shortVideoShareTimes: '短视频分享次数',
  shortVideoLikeTimes: '短视频喜欢次数',
  adClickTimes: '广告点击次数',
  // 签到中心
  signCenter: '签到中心',
  signRules: '签到规则',
  memberSign: '会员签到',
  continueSign: '已连续签到',
  sign: '签到',
  signIn: '已签到',
  signInfo: '签到信息',
  signTotalMoney: '累计签到彩金',
  signContinueDay: '连续签到天数',
  signEndDate: '活动结束时间',
  signOrNot: '是否签到',
  signSuccess: '签到成功',

  //  下载页
  downloadTitle: '遇见下一个{siteTitle}的时代', // 遇见下一个Titok站时代
  downloadBtn: '下载APP', // 下载APP
  downloadAndroid: '下载Android', // 下载Android
  downloadIos: '下载Ios', // 下载Ios
  // 他人主页
  shareHomepage: '分享主页', // 分享主页

  // 小说
  novelAddToShell: '添加到书架',
  novelAddedToShell: '已添加到书架',
  novelPerson: '{0}人',
  novelReadCount: '累计人气',
  novelReadNow: '立即阅读',
  novelHot: '热门小说',
  novelIndex: '目录',
  novelChapterNumber: '第{0}章',
  novelLastChapter: '上一章',
  novelNextChapter: '下一章',
  novelChapterCount: '共{0}章',
  novelSortUp: '正序',
  novelSortDown: '倒序',
  novelMyShell: '我的书架',
  novelClass: '分类',
  novelNum: '{0}部',
  novelEnterBook: '请输入书名',
  novelHistory: '阅读历史',
  novelNoVipTips: '您还不是VIP，请立即充值',
  novelSearchHistory: '搜索历史',
  novelAlreadyInShell: '已加入书架',
  novelSearchDiscover: '搜索发现',
  novelSort: '分类',
  novelRank: '排行',
  novelSerial: '连载',
  novelFree: '免费',
  novelDone: '完本',
  novelCollect: '已加入书架',
  novelUnCollect: '已移出书架',
  novelChoice: '畅销精选',

  // 维护
  maintenanceTitle: '系统维护', // 系统维护
  maintenanceTime: '维护时间', // 维护时间

  // im
  message: '消息',
  privateMessage: '发私信',
  followBack: '回关',
  setAlias: '设置备注',
  newFriend: '新朋友',
  friend: '朋友',
  searchUser: '搜索用户',
  silent: '免打扰',
  stickToTop: '置顶聊天',
  addToBlacklist: '拉黑',
  sendMessage: '发送消息',
  allEmoji: '全部表情',
  deleteFriend: '删除好友',
  unfollow: '取消关注',
  enterAlias: '输入备注',
  follow: '关注',
  addUser: '添加用户',
  remove: '移除',
  search: '搜索',
  followedYou: '关注了你',
  cancelSilent: '取消免打扰',
  setTop: '置顶',
  cancelSetTop: '取消置顶',
  justNow: '刚刚',
  minuteAgo: '{0}分钟前',
  hourAgo: '{0}小时前',
  dayAgo: '{0}天前',
  youAreNotFriend: '您还不是对方好友，对方回复您后可继续发送消息',
  yourBlockHim: '您已经拉黑对方，请解除后继续发送消息',
  yourAreBlock: '由于对方隐私设置，ta无法收到您的消息',
  audioTooShort: '录音时间太短',
  notSupportRecord: '设备不支持录音',
  holdToTalk: '按住说话',
  releaseSend: '松手发送，上滑取消',
  releaseCancel: '松手取消',
  whoFollowedYou: '{0}刚关注了你',
  whoSendYouMessage: '收到{0}新消息',
  delete: '删除',
  shareFailed: '分享失败',
  shareSucceed: '分享成功',
  shareMovie: '影片分享',
  shareShortVideo: '短视频分享',
  shareNovel: '小说分享',
  shareToFriend: '分享给好友',
  noFriends: '暂无朋友',
  conversationWarning: '由于未与对方互相关注，在收到回复前你只能发送一条消息',
  toFollowSomeOne: '还没有朋友关注你，去关注其他人吧~',

  restPasswordEnterNewRePsd: '请再次输入新密码',
  phoneLogin: '手机号登录',
  accountLogin: '账户密码登录',
  noAccount: '还没有账号',
  goRegister: '去注册',
  accountPasswordRegister: '账户密码注册',
  phoneRegister: '手机号注册',
  loginGetCode: '获取验证码',
  phoneReset: '手机号找回',
  resetWarning: '未绑定手机号或者邮箱无法重置密码',
  emailReset: '邮箱找回',
  lastMsgEffect: '验证码五分钟内有效',
  reGetVerifyCode: '再次发送验证码',
  restPasswordNotEquale: '两次密码不一致',

  commentReply: '回复',
  commentClickLoadMore: '点击查看更多',
  commentExpandMore: '展开更多回复',
  commentCollapse: '收起',
  commentEnterTextOrImage: '请输入评论或者图片',
  commentAllMsg: '全部消息',
  commentMentionMe: '@我的',
  commentGetReply: '收到的评论',
  commentReplySuccess: '回复成功',
  commentMentionYou: '提到了你',
  commentYou: '评论了你',
  commentReplyYou: '回复了你',
  commentInteraction: '互动消息',
  commentHaveDeleted: '评论已删除',
  commentConfirmDelete: '您确定要删除这条评论吗？',
  commentNoMsg: '暂无互动消息',
  // 社区
  // community: '社区',
  newest: '最新',
  marrow: '精华',
  communityVideo: '视频',
  scan: '浏览',
  like: '点赞',
  comment: '评论',
  postsDetail: '帖子详情',
  choseTopic: '选择话题',
  publishMoney: '解锁金币（最高可设置99金币）',
  // publishTitle: '填写标题',
  publishTitlePlaceholder: '填写符合视频内容的标题',
  publishContent: '填写内容',
  publishContentPlaceholder: '这里就写一些内容',
  publicImg: '上传图片',
  publicVideo: '上传影片',
  publicVideoTips: '最大100M以内',
  publicImgTips: '最大每张1M',
  buyPosts: '购买帖子',
  buyPostsTips: '解锁后可查看全部内容',
  buyPostsTips1: '预览播放结束，需要{0}金币购买',
  buyMoneys: '账户余额不足{0}金币，请充值金币',
  buyMoney: '账户余额不足，请充值金币',
  buyVip: '预览播放结束，请购买vip',
  RechargeMoney: '金币充值',
  previewOver: '预览播放结束，',
  limitScanVideo: '预览{0}秒 {1}金币观看完整视频',
  //  邀请分享
  inviteUserWatchTip: '邀请一个用户即可无限看5天',
  inviteUserRateTip: '邀请的用户充值返现40金币',
  adultVideos: '成人短视频',
  codeScan: '扫描二维码',
  downAppWatch: '下载APP立即观看',
  yourInviteCode: '你的邀请码',
  downQrCode: '下载二维码',
  copyLinkShare: '复制链接分享',

  //  邀请记录
  inviteRecord: '邀请记录',
  invitedFriendLoginSuccess: '被邀请的好友需要登录之后才算邀请成功',

  //  推广代理
  promotion: '推广代理',
  activityContent: '活动内容',
  performanceTotal: '总业绩',
  detailsRevenue: '收益明细',
  revenueTotal: '总收益',
  opportunitySeize: '把握时机',
  wealthFreedom: '用行动实现财富自由',
  inviteSuccessfullyRechargeUser: '成功邀请1名用户充值成功即可返利{0}%',
  nowPromote: '立即推广',
  richClose: '变富近在咫尺',
  promotionChannel: '如果你有推广渠道想赚钱成为官方代理',
  percentageProportion: '最高80%分成 月入10万不是梦',
  serviceContact: '联系客服',
  promoteHow: '如何推广',
  inviteSuccessfullyVipUser: '邀请一人可获得3天VIP,可无限叠加～',
  stepOne: '第一步',
  stepTwo: '第二步',
  stepThree: '第三步',
  clickSave: '点击【保存图片】或【复制链接】',
  sendInfo: '将图片或者链接通过各种渠道发送出去',
  exampleOne: '如常用的社交软件',
  exampleTwo: '如常用的游戏软件',
  inviteDownloadAward: '被邀请人下载进入app即可自动绑定，被邀请人充值立马获得返利（可提现）',

  //  我加入的粉丝团
  myFanClubJoin: '粉丝团',
  fanClubNumber: '粉丝团人数',
  joinedDay: '已加入{day}天',

  //  创作者中心
  searchVideo: '搜索视频/标签/用户',
  workManage: '作品管理',
  published: '已发布',
  reviewPending: '待审核',
  fansExclusive: '粉丝专属',
  greatGods: '大神榜',
  haveNumPeople: '已有{num}人',
  becomeCreator: '成为18Porn创作者',
  makeMoneyNow: '立即赚钱',
  createdYourselfFanGroup: '创建了自己的粉丝团',
  createFanGroup: '创建粉丝团',
  creationStrategy: '创作攻略',

  //  创建粉丝团
  fanClubName: '粉丝团名称',
  fanClubNamePlaceholder: '请输入10个字以内',
  fanClubNameMsg: '请输入粉丝团名称',
  fanClubIntroduction: '粉丝团简介',
  fanClubIntroductionMsg: '请输入粉丝团简介',
  fanClubMonth: '粉丝团月票',
  fanClubMonthMsg: '请输入粉丝团月票',
  fanClubSeason: '粉丝团季票',
  fanClubSeasonMsg: '请输入粉丝团季票',
  fanClubYear: '粉丝团年票',
  fanClubYearMsg: '请输入粉丝团年票',
  ticketPlaceholder: '设置大于30金币',

  //  排行榜
  ranking: '排行榜',
  richRanking: '土豪榜',
  originalWorkRanking: '原创作品榜',
  originalPopularityRanking: '原创人气榜',
  originalLikeRanking: '原创获赞榜'
};
